import { useQuery } from '@tanstack/react-query';
import { getEventsByAlert } from '@src/api/manualAlerts';
import { get } from 'lodash';
import { trackQueryError } from '@utils/sensor/apptracker';
import { useMemo } from 'react';
import moment from 'moment';

const defaultValue = null;

// fetch all events of an alert
function useFetchEventsByAlert({ alertId, enabled = true }) {
  const interval = useMemo(() => {
    const to = moment().startOf('hour');
    const from = moment(to).subtract(30, 'days').startOf('hour');
    return { from: from.format(), to: to.format() };
  }, []);

  // stale time prevents redundant calls from multiple subscribers
  const { data, dataUpdatedAt, isLoading, isError } = useQuery(
    ['manual-alert', alertId, interval],
    () => {
      return getEventsByAlert(alertId, { params: { ...interval } }).then((response) => {
        return get(response, ['data'], null);
      });
    },
    {
      retry: 3,
      refetchOnWindowFocus: false,
      enabled: enabled && !!alertId,
      staleTime: 5 * 60 * 1000, // 5m
      // notifyOnChangeProps: 'tracked',
      placeholderData: defaultValue,
      onError: (err) => {
        trackQueryError({ type: 'events-by-manual-alert', err });
      },
    },
  );

  return { data, dataUpdatedAt, isLoading, isError, interval };
}

export default useFetchEventsByAlert;
